import { useEffect } from "react";
import Footer from "../../reusableUi/Footer";
import LocationsHero from "./components/LocationsHero";
import LocationsMain from "./components/LocationsMain";
export default function ServicesPage() {
  useEffect(() => {
    // Page title
    document.title =
      "Plumbing Services in Chicago Neighborhoods | Local Plumber";

    // Meta description
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Professional plumbing services across Chicago neighborhoods including Lincoln Park, Lakeview, Hyde Park, Wicker Park, and more. Fast local response and licensed plumbers.",
      );
    }
  }, []);
  return (
    <div className="space-y-26">
      <LocationsHero />
      <LocationsMain />
      <Footer />
    </div>
  );
}
